import React, { FC, useState } from 'react'
import { ModalWrapper } from '../../../../../Components'
import productLeaseService from '../../../../../Services/productLeaseService'
import { useParams } from 'react-router-dom'
import Swal from 'sweetalert2'

interface props {
  show: boolean
  close: () => void
  balance: number
  currency: string
}
const Pay: FC<props> = ({ show, close, balance, currency }) => {
  const { uuid } = useParams<{ uuid: string }>()
  const [loading, setLoading] = useState(false)
  const [amount, setAmount] = useState(0)

  const makePayment = async () => {
    setLoading(true)
    await productLeaseService.pay(uuid, { amountMajor: amount }).then(
      () => {
        setLoading(false)
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Payment successful',
          showConfirmButton: false,
          timer: 5500,
        })
        close()
      },
      (error: { response: { data: { error: string } } }) => {
        setLoading(false)
        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 5500,
        })
      },
    )
  }
  return (
    <ModalWrapper
      showModal={show}
      closeModal={close}
      title='Pay for product lease'
      hideHeader={false}
    >
      <div className='row'>
        <div className='col-md-12'>
          <div className='form-group'>
            <label htmlFor='amount'>Amount</label>
            <input
              type='number'
              className='form-control mt-2'
              id='amount'
              defaultValue={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
            />
          </div>
        </div>
      </div>
      <button className='btn btn-default mt-4 px-4' onClick={makePayment} disabled={loading}>
        {loading ? 'Please wait...' : 'Pay Now'}
      </button>
    </ModalWrapper>
  )
}

export default Pay
